import React, { useState } from "react";
import { MessageSquarePlus } from "lucide-react";
import FeedbackModal from "./FeedbackModal";

/**
 * Bottone discreto e autonomo che apre il FeedbackModal.
 * Gestisce internamente lo stato "aperto/chiuso": può essere montato
 * ovunque nell'app (es. TopBar, Sidebar, Dashboard, pagina Profilo)
 * senza bisogno di props aggiuntive oltre a `darkMode`.
 */
export default function FeedbackTriggerButton({ darkMode = false, className = "" }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
          darkMode
            ? "bg-forfy-500/15 text-forfy-300 hover:bg-forfy-500/25"
            : "bg-forfy-50 text-forfy-700 hover:bg-forfy-100"
        } ${className}`}
        aria-haspopup="dialog"
        aria-label="Lascia un feedback"
      >
        <MessageSquarePlus className="w-3.5 h-3.5" />
        Feedback
      </button>

      <FeedbackModal isOpen={isOpen} onClose={() => setIsOpen(false)} darkMode={darkMode} />
    </>
  );
}
